module.exports = __webpack_public_path__ + "img/icon_guides_and_videos_hover.0dbb4efb.svg";